import ProfileImage from '../images/profile.png';

export default ProfileImage;